// angular
import {Component, inject} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {Router, RouterLink} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";
// material angular
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
// components
import {InputComponent} from "@core/components/input/input.component";
import {ButtonComponent} from "@core/components/button/button.component";
// service
import {AuthService} from "@auth/shared/services/auth.service";
import {StorageService} from "@shared/services/storage.service";
import {LoadingService} from "@app/shared/services/loading.service";
import {MainConfigurationService} from "@app/shared/services/main-configuration.service";
import {PreventFormSubmitDirective} from "@app/core/directives/form-enter-handler.directive";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    ButtonComponent,
    TranslateModule,
    NgOptimizedImage,
    MatIconModule,
    MatFormFieldModule,
    RouterLink,
    PreventFormSubmitDirective,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  loginForm: FormGroup;
  isPasswordVisible: boolean = false;
  isLoading: boolean = false;

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  get passwordFieldType(): string {
    return this.isPasswordVisible ? "text" : "password";
  }

  // dependencies
  private readonly fb = inject(FormBuilder);
  private readonly _mainConfigurationService = inject(MainConfigurationService);
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _storageService = inject(StorageService);
  private readonly _loadingService = inject(LoadingService);

  constructor() {
    this.loginForm = this.fb.group({
      mobile_number: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  returnZero() {
    return 0;
  }

  submit() {
    this.loginForm.markAllAsTouched();

    if (this.loginForm.invalid || !this.loginForm.dirty) return;

    this._loadingService.setLoading(true);

    const {mobile_number, password} = this.loginForm.value;
    let params: any = {
      mobile: mobile_number,
      password,
    };
    if (
      this._storageService.getChatId() &&
      this._storageService.getMemberId()
    ) {
      params = {
        ...params,
        chatId: this._storageService.getChatId(),
        memberId: this._storageService.getMemberId(),
      };
    }
    // set loading state
    this.isLoading = true;

    this._authService.login(params).subscribe({
      next: (res) => {
        if (res) {
          this._storageService.setToken(res.access_token);
          this._storageService.setRefreshToken(res.refresh_token);

          this._mainConfigurationService.init().then(() => {
            if (this._authService.cashUrlForAfterLogin()) {
              this._router.navigate([
                `/${this._authService.cashUrlForAfterLogin()}`,
              ]);
            } else {
              this._router.navigate(["/"]);
            }
          });
          this._loadingService.setLoading(false);
        }
      },
      error: () => {
        this.isLoading = false;
        this._loadingService.setLoading(false);
      },
      complete: () => {
        this.isLoading = false;
        this._loadingService.setLoading(false);
      },
    });
  }
}
